// TODO: @jibin2706 use this type in all places
export enum DocumentTypes {
  PRIVATE_DOCS = 'private_docs',
  ITEMS = 'items',
  ASSIGNMENTS = 'assignments',
  TEMPLATES = 'templates',
  BRIEFS = 'briefs'
}

export const getEditorType = (type: DocumentTypes): PepperDocTypes => {
  switch (type) {
    case DocumentTypes.ASSIGNMENTS:
      return 'PEPPER_DOC'
    case DocumentTypes.PRIVATE_DOCS:
      return 'PRIVATE_DOC'
    case DocumentTypes.TEMPLATES:
      return 'TEMPLATE'
    case DocumentTypes.BRIEFS:
      return 'BRIEF'
    default:
      throw new Error('Invalid Document Type')
  }
}

// TODO: update type to PepperDocTypes
export const getURLFromAPIType = (type?: string): string => {
  switch (type) {
    case 'TEMPLATE':
      return 'templates'
    case 'PRIVATE_DOC':
      return 'items'
    case 'PRIVATE_ITEM_PUBLIC_VIEW_PEPPER_DOC':
      return 'items'
    case 'BRIEF':
      return 'briefs'
    default:
      return 'assignments'
  }
}

export const getIsPublicDocFromAPIType = (type?: string): boolean => {
  switch (type) {
    case 'PUBLIC_VIEW_PEPPER_DOC':
      return true
    case 'PRIVATE_ITEM_PUBLIC_VIEW_PEPPER_DOC':
      return true
    default:
      return false
  }
}
